import type { NormalizedParticipant } from "./registration-validation";

const PARTICIPANT_COUNT_KEY = "participantCount";

export function participantsToMetadata(
  eventSlug: string,
  participants: NormalizedParticipant[]
) {
  return {
    eventSlug,
    [PARTICIPANT_COUNT_KEY]: String(participants.length),
    ...Object.fromEntries(
      participants.map((participant, index) => [
        `participant_${index}`,
        JSON.stringify(participant),
      ])
    ),
  };
}

export function participantsFromMetadata(metadata: Record<string, string>) {
  const count = Number.parseInt(metadata[PARTICIPANT_COUNT_KEY] || "0", 10);
  if (!Number.isFinite(count) || count <= 0) {
    return [];
  }

  const participants: unknown[] = [];
  for (let index = 0; index < count; index += 1) {
    const raw = metadata[`participant_${index}`];
    if (!raw) {
      throw new Error(`Missing participant metadata for index ${index}`);
    }

    participants.push(JSON.parse(raw));
  }

  return participants;
}

export function getPaymentIntentIdFromClientSecret(clientSecret: string) {
  const separator = "_secret_";
  if (!clientSecret.includes(separator)) {
    return "";
  }

  return clientSecret.split(separator)[0] || "";
}
